import type { Permissions } from '../api-types/project';
import type { Builder } from './types';

const BASE_PATH = '/v1/user';

export const projectEndpoints = (builder: Builder) => ({
  getPermissions: builder.query<Permissions, string>({
    query: (projectId) => ({
      url: `${BASE_PATH}/permissions`,
      method: 'GET',
      headers: { 'Project-Id': projectId },
      params: { projectId: projectId },
    }),
    providesTags: (result, error, projectId) => [{ type: 'Permissions', id: projectId }],
  }),
});
